/**
 * KAN-850: "Следующая партия" of a campaign list.
 *
 * Creates an empty copy of the list on the server (same kind, owner, schema,
 * upload settings), then opens the upload page of the new list: the upload
 * form pre-fills from the copied upload settings (latest preset of the kind).
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { extractErrorMessage } from '@/lib/extractErrorMessage';
import { datasetsApi } from '@/services/api/datasets';
import type { Dataset } from '@/types/dataset';

export const NEXT_BATCH_LABEL = 'Следующая партия';

export function uploadPathOf(dataset: Pick<Dataset, 'id'>): string {
  return `/clients/cold-calls/${dataset.id}/upload`;
}

export function useNextBatch() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (sourceId: string) => datasetsApi.nextBatch(sourceId),
    onSuccess: (dataset: Dataset) => {
      queryClient.invalidateQueries({ queryKey: ['datasets'] });
      // The copied upload settings are now the latest preset of the kind.
      queryClient.invalidateQueries({ queryKey: ['datasetUploadPresets'] });
      toast.success(`Создан список ${dataset.name}`);
      navigate(uploadPathOf(dataset));
    },
    onError: (err: unknown) => {
      toast.error(extractErrorMessage(err, 'Не удалось создать следующую партию'));
    },
  });
}
